import React, { useCallback } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import CarouselLeft from '../../../assets/img/rewamp/icons/carousel-left.svg';
import CarouselRight from '../../../assets/img/rewamp/icons/carousel-right.svg';
import Image1 from '../../../assets/img/rewamp/clients/1.jpg';
import Image2 from '../../../assets/img/rewamp/clients/2.jpg';
import Image3 from '../../../assets/img/rewamp/clients/3.jpg';
import Image4 from '../../../assets/img/rewamp/clients/4.jpg';
import Image5 from '../../../assets/img/rewamp/clients/5.jpg';
import Image6 from '../../../assets/img/rewamp/clients/6.jpg';
import Image7 from '../../../assets/img/rewamp/clients/7.jpg';
import Image8 from '../../../assets/img/rewamp/clients/8.jpg';


const images = [
    Image1,
    Image2,
    Image3,
    Image4,
    Image5,
    Image6,
    Image7,
    Image8
];

export default function ClientsCarousel() {
    // Initialize Embla with loop and alignment options
    const [emblaRef, emblaApi] = useEmblaCarousel({
        loop: true,
        align: 'center',
        skipSnaps: false
    });

    // Callback functions for your custom arrows
    const scrollPrev = useCallback(() => {
        if (emblaApi) emblaApi.scrollPrev();
    }, [emblaApi]);

    const scrollNext = useCallback(() => {
        if (emblaApi) emblaApi.scrollNext();
    }, [emblaApi]);

    return (
        <div className="clients-carousel-wrapper">
            {/* Custom SVG Arrows positioned absolutely via CSS */}
            <img
                src={CarouselLeft}
                className="arrow-left"
                onClick={scrollPrev}
                alt="Previous"
            />
            <img
                src={CarouselRight}
                className="arrow-right"
                onClick={scrollNext}
                alt="Next"
            />

            {/* Embla Viewport */}
            <div className="embla" ref={emblaRef}>
                <div className="embla__container">
                    {images.map((item, i) => (
                        <div key={i} className="embla__slide">
                            {/* <div className="image-wrapper">
                                <img
                                    src={item.img}
                                    className="carousel-image"
                                    alt=""
                                />
                            </div> */}
                            <div className="client-image-wrapper">
                                <img src={item} className="client-image" alt={"image"} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}